const messages = {
  EMAIL_SENT_SUCCESSFULLY: "Request email sent successfully!",
  SOMETHING_WENT_WRONG: "Something went wrong!",
};

export { messages };
